import axios from "axios";
import dayjs, { isDayjs } from "dayjs";

import { logout } from "src/common/actions/auth.action";
import { store } from "src/store";

import { formatRequestData } from "./funcs";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (req) => {
    if (req.params) {
      Object.keys(req.params).forEach((key) => {
        if (req.params[key] instanceof Date || isDayjs(req.params[key])) {
          req.params[key] = dayjs(req.params[key]).format("YYYY-MM-DD");
        }
        if (
          req.params[key] === "all" ||
          req.params[key] === "" ||
          typeof req.params[key] === "undefined"
        ) {
          delete req.params[key];
        }
      });
    }
    if (req.method === "post" || req.method === "put") {
      if (
        req.data &&
        !(req.data instanceof FormData) &&
        !(req.data instanceof URLSearchParams)
      ) {
        req.data = formatRequestData(req.data);
      }
    }
    return req;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      store.dispatch(logout());
      return null;
    }

    const _error = {
      data: error?.response?.data?.data || null,
      message: error?.response?.data?.message || error?.message || "",
      status: error?.response?.status,
    };

    return Promise.reject(_error);
  },
);
